import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-05/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml: `The acoustic waveguide below is excited by a loudspeaker. Its pressure response has a maximum at low frequencies.</br>Note that the dimensions given below include length corrections. Calculate the resonance frequency of this system.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/05/task/task-3.svg`,
                },
              },
              styles: {
                padding: "3%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};
export default task;
